export const environment = {
  envName: 'production',
  production: true,
  baseHref: '/',
  apiHost: 'https://meble.pro/api/v1',
  siteUrl: 'https://meble.pro'
};
